import styled from "styled-components"

export const Span = styled.span`
  float: right;
  &:hover {
    cursor: pointer;
  }
`

export const Reference = styled.div`
  border: 1px solid #e6e6e6;
  padding: 24px;
  border-radius: 12px;
`
